import http from "./HttpService";

const BASE_SERVICE_URL = "gamification-service";

export default {
  getCampaignBanners(request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          BASE_SERVICE_URL + "/v1/campaign-banners",
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  }
};
